import request from '../utils/fetch';

// 获取预设对象列表
export const getObjectList = async (): Promise<any> => {
  return request('/model/v1/conflict/preObject/list', {
    // tokenFree: true,
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};

// 添加预设对象
export const getPreObjectInfo = async (preObjectId: string): Promise<any> => {
  return request(`/model/v1/conflict/preObject/info/${preObjectId}`, {
    // tokenFree: true,
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};

// 添加预设对象
export const addPreObject = async (data: any): Promise<any> => {
  return request('/model/v1/conflict/preObject/add', {
    // tokenFree: true,
    method: 'POST',
    data,
  });
};

// 添加预设对象
export const updatePreObject = async (data: any): Promise<any> => {
  return request('/model/v1/conflict/preObject/update', {
    // tokenFree: true,
    method: 'POST',
    data,
  });
};

// 对象复制
export const copyPreObject = async (preObjectId: string): Promise<any> => {
  return request(`/model/v1/conflict/preObject/copy/${preObjectId}`, {
    // tokenFree: true,
    method: 'POST',
  });
};

// 对象删除
export const deletePreObject = async (preObjectId: string): Promise<any> => {
  return request(`/model/v1/conflict/preObject/delete/${preObjectId}`, {
    // tokenFree: true,
    method: 'DELETE',
  });
};

// 对象发布
export const publishPreObject = async (data: any): Promise<any> => {
  return request(`/model/v1/conflict/preObject/published/set`, {
    // tokenFree: true,
    method: 'POST',
    data,
  });
};
